import { isAxiosError } from "axios";

/**
 * Spring Boot `ProblemDetail` and similar shapes expose a human-readable `detail` string.
 */
export function apiErrorUserMessage(err: unknown, fallback: string): string {
  if (!isAxiosError(err)) {
    return err instanceof Error ? err.message : fallback;
  }
  const data = err.response?.data;
  if (data && typeof data === "object" && "detail" in data) {
    const d = (data as { detail?: unknown }).detail;
    if (typeof d === "string" && d.trim()) return d;
  }
  return fallback;
}

/** Softer banner for “too early / window ended” vs other 409 conflicts on connect video. */
export function connectVideoConflictSeverity(detail: string): "error" | "warning" {
  if (
    detail.startsWith("Your consultation is scheduled for") ||
    detail.startsWith("The video period for this appointment has ended")
  ) {
    return "warning";
  }
  return "error";
}
